module.exports = __webpack_public_path__ + "images/emoji/horse_racing.10b76c1bc774fc00e1bf.png";